'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objDiff = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _FormRenderProvider = require('./FormRenderProvider');

var _FormRenderProvider2 = _interopRequireDefault(_FormRenderProvider);

var _primitives = require('./primitives');

var _reactRedux = require('react-redux');

var _layout = require('./layout');

var _utils = require('./utils');

var _reactApollo = require('react-apollo');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Usage
// <FormProvider mode={add|edit|display|hybrid} fields={fields} saveUpdates={} createNew={} fetchData={} renderInputFields={} renderDisplayFields={} renderLabels={}>
// </FormProvider>
// Controlled Component / Uncontrolled Component for Fields ...


var propTypes = {
  name: _propTypes2["default"].string.isRequired,
  fields: _propTypes2["default"].object.isRequired,
  mode: _propTypes2["default"].string,
  renderDisplay: _propTypes2["default"].func,
  renderInput: _propTypes2["default"].func,
  renderLabel: _propTypes2["default"].func,
  renderInfo: _propTypes2["default"].func,
  renderError: _propTypes2["default"].func,
  renderField: _propTypes2["default"].func,
  InputFormLayout: _propTypes2["default"].func,
  DisplayFormLayout: _propTypes2["default"].func,
  LoadingScreen: _propTypes2["default"].func,
  ErrorScreen: _propTypes2["default"].func,
  initialValuesFromData: _propTypes2["default"].func,
  data: _propTypes2["default"].any
};
var defaultProps = {
  id: "",
  mode: 'edit',
  renderDisplay: null,
  renderInput: null,
  renderLabel: null,
  renderField: null,
  renderInfo: null,
  renderError: null,
  InputFormLayout: _layout.DefaultFormLayout,
  DisplayFormLayout: _layout.DefaultFormLayout,
  LoadingScreen: function LoadingScreen() {
    return _react2["default"].createElement(_primitives.Text, null, 'Loading ...');
  },
  ErrorScreen: function ErrorScreen() {
    return _react2["default"].createElement(_primitives.Text, null, 'An error has occurred ...');
  },
  data: null
};

var objDiff = exports.objDiff = function objDiff(obj1, obj2) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var commonKeys = [];

  if (obj1 !== obj2) {
    console.log('At', path, 'NOT ===');

    if (obj1 instanceof Object) {
      Object.keys(obj1).forEach(function (key) {
        if (obj2[key]) {
          objDiff(obj1[key], obj2[key], path + '.' + key);
        } else {
          console.log(key, 'not on both at', path);
        }
      });
    } else {
      console.log('object are', obj1, obj2);
    }
  }
};

var TheForm = function (_Component) {
  _inherits(TheForm, _Component);

  function TheForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TheForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TheForm.__proto__ || Object.getPrototypeOf(TheForm)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function () {
      return _this.props.submit();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TheForm, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        fields: (0, _utils.processFields)(this.props.fields).fields,
        mode: this.props.mode === "displayOnly" ? "display" : this.props.mode,
        setMode: this.props.setMode,
        values: this.props.initialValues,
        submit: this.submit,
        invalid: this.props.invalid,
        formName: this.props.name
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {// console.log('NEXT PROPS=', nextProps)
      // objDiff(this.props, nextProps)
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // console.log(nextProps)
      var reRender = this.props.children && this.props.children !== nextProps.children || !this.props.children && (this.props.mode === 'add' || this.props.mode === 'edit') && this.props.InputFormLayout !== nextProps.InputFormLayout || !this.props.children && !(this.props.mode === 'add' || this.props.mode === 'edit') && this.props.DisplayFormLayout !== nextProps.DisplayFormLayout || this.props.mode !== nextProps.mode || this.props.initialized !== nextProps.initialized || this.props.id !== nextProps.id || this.props.data && nextProps.data && this.props.data.loading !== nextProps.data.loading || nextProps.mode === "display" && this.props.data !== nextProps.data; //// console.log(reRender)

      return reRender;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          fields = _props.fields,
          InputFormLayout = _props.InputFormLayout,
          DisplayFormLayout = _props.DisplayFormLayout,
          mode = _props.mode,
          initialized = _props.initialized,
          LoadingScreen = _props.LoadingScreen,
          submit = _props.submit,
          setMode = _props.setMode,
          children = _props.children,
          id = _props.id,
          query = _props.query;

      var _ref2 = this.props.data || {},
          loading = _ref2.loading,
          error = _ref2.error; // console.log(initialized);

      /*if (!initialized) {
        return <LoadingScreen />
      } else {*/
      // console.log('Rerendering')
      // console.log('CHILDREN ARE:', this.props.children)


      if (!children || children.length == 0) {
        var FormLayout = DisplayFormLayout;

        if (mode === 'add' || mode === 'edit') {
          FormLayout = InputFormLayout;
        }

        return _react2["default"].createElement(FormLayout, {
          mode: mode,
          submit: submit,
          setMode: setMode,
          fields: fields,
          query: query,
          data: this.props.data,
          id: id,
          apolloClient: this.props.client,
          changeFieldValue: this.props.changeFieldValue
        });
      } else {
        // console.log('render children')
        if (children instanceof Function) {
          return children({
            submit: submit,
            setMode: setMode,
            mode: mode,
            fields: fields
          });
        }

        return children;
      } //}

    }
  }]);

  return TheForm;
}(_react.Component);

TheForm.childContextTypes = {
  formName: _propTypes2["default"].string,
  fields: _propTypes2["default"].object,
  mode: _propTypes2["default"].string,
  setMode: _propTypes2["default"].func,
  values: _propTypes2["default"].object,
  submit: _propTypes2["default"].func,
  invalid: _propTypes2["default"].bool
};
TheForm = (0, _reduxForm.reduxForm)({
  enableReinitialize: true,
  touchOnBlur: true,
  destroyOnUnmount: false
})(TheForm);

var mapStateToProps = function mapStateToProps() {};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref3) {
  var name = _ref3.name;
  return {
    changeFieldValue: function changeFieldValue(fieldName, value) {
      return dispatch((0, _reduxForm.change)(name, fieldName, value));
    }
  };
};

TheForm = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TheForm);
TheForm = (0, _reactApollo.withApollo)(TheForm);

var FormProvider = function (_Component2) {
  _inherits(FormProvider, _Component2);

  function FormProvider() {
    _classCallCheck(this, FormProvider);

    return _possibleConstructorReturn(this, (FormProvider.__proto__ || Object.getPrototypeOf(FormProvider)).apply(this, arguments));
  }

  _createClass(FormProvider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {// console.log(nextProps)
      // objDiff(this.props, nextProps)
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var shouldUpdate = this.props.mode !== nextProps.mode || this.props.id !== nextProps.id || this.props.data && nextProps.data && this.props.data.loading !== nextProps.data.loading || this.props.mode === "display" && this.props.data !== nextProps.data; // console.log(shouldUpdate, this.props.mode, nextProps.mode, this.props.data.loading,  nextProps.data.loading, this.props.data, nextProps.data)

      return shouldUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          mode = _props2.mode,
          id = _props2.id,
          data = _props2.data,
          fields = _props2.fields,
          LoadingScreen = _props2.LoadingScreen,
          ErrorScreen = _props2.ErrorScreen,
          InputFormLayout = _props2.InputFormLayout,
          DisplayFormLayout = _props2.DisplayFormLayout,
          initialValuesFromData = _props2.initialValuesFromData; // console.log('FormProvider render', mode)
      // console.log('data=', data)

      var initialValues = _extends({}, this.props.initialValues);

      if (initialValuesFromData && mode !== "add") {
        // console.log('Getting initialValuesFromData')
        initialValues = _extends({}, initialValuesFromData(data));
      }

      var _processFields = (0, _utils.processFields)(fields),
          keyValueFields = _processFields.keyValueFields; // console.log('INITIAL before', this.props.initialValues, initialValues)


      (0, _utils.keyValueArrayToObject)(initialValues, keyValueFields); // console.log('INITIAL after', initialValues)

      var _ref4 = data || {},
          loading = _ref4.loading,
          error = _ref4.error;

      if (loading) {
        return _react2["default"].createElement(LoadingScreen, null);
      } else if (error) {
        return _react2["default"].createElement(ErrorScreen, {
          error: error
        });
      } else if (!data && mode == "add" || data) {
        return _react2["default"].createElement(_FormRenderProvider2["default"], {
          renderDisplay: this.props.renderDisplay,
          renderInput: this.props.renderInput,
          renderLabel: this.props.renderLabel,
          renderField: this.props.renderField,
          renderInfo: this.props.renderInfo,
          renderError: this.props.renderError
        }, _react2["default"].createElement(TheForm, _extends({
          form: this.props.name
        }, this.props, {
          id: id,
          mode: mode,
          data: data,
          setMode: this.props.setMode,
          setId: this.props.setId,
          InputFormLayout: InputFormLayout,
          DisplayFormLayout: DisplayFormLayout,
          initialValues: initialValues || {}
        })));
      } else {
        return _react2["default"].createElement(_primitives.View, null);
      }
    }
  }]);

  return FormProvider;
}(_react.Component);

FormProvider.propTypes = propTypes;
FormProvider.defaultProps = defaultProps;
exports["default"] = FormProvider;